<template>
  <div id="cart" class="full_layout cart" v-loading.fullscreen="loading">
    <div v-if="list">
      <div class="cartTitle" v-if="addressList!=null&&list!=null">
        <h3>Select shipping address<span>({{list.Details.length}} items)</span></h3>
      </div>
      <div v-if="addressList!=null">
        <to-address :title='title' :domVisible='dislogType.address' :list='addressItem' :isSet="isSet" @closeDialog="closeDialog" v-if="dislogType.address" />
        <div class="addressShow" :class="isAddShow?'on':''">
          <ul class="addressList">
            <!-- [item._id==list.AddressId?'on':isAdd==index?'on':''] -->
            <li v-for="(item,index) in addressList" :key='index' :class="isAdd==index?'on':''" @click="setOnlyAddress(index,item)">
              <div>
                <div class="addressName">{{item.CompanyName}} ({{item.TaxCode}})</div>
                <div class="addressName">{{item.UserName}} ({{item.Country}})</div>
                <div class="addressText line_txt2">{{item.Provice|setProvice}} {{item.AddressDetail}} {{item.ZipCode}}</div>
                <div class="addressPhone">{{item.Mobile}}</div>
                <div class="addressPhone">{{item.Email}}</div>
              </div>
              <span class="default" v-if="item.IsDefault">Default</span>
              <span class="setAddress" @click="setAddress('address',1,item)">	Edit</span>
            </li>
          </ul>
        </div>
        <div class="setInfoBox space_between" :class="addressCount>0?'':'addressShow'">
          <div class='isShow' @click="IsShow" v-if="addressCount>4">{{isAddShow?'Hide':'Show all addresses'}}</div>
          <div class='isShow' v-else></div>
          <div class="setinfo" @click="setAddress('address',0)">Add shipping address</div>
        </div>
      </div>
      <div class='stageDetail' v-if="list.Details[0].Presale==1||list.OrderPresale==1">
        <div class="stageOne" :class="(list.Details[0].Presale==1&&!ischeck)||(ischeck&&!list.IsPayDeposit)?'on':''">
          <div class="">
            <div class="stageRadius"></div>
            <div>Step 1</div>
            <div v-if="!ischeck">Pay Deposit <span class="price">€ {{priceCount(list.Details[0].AdvancePrice,list.Details[0].Num,'multi').toLocaleString()}}</span></div>

            <div v-if="ischeck">Pay Deposit <span class="price">€ {{list.AdvancePrice.toLocaleString()}}</span></div>
          </div>
          <span class="span"><i></i></span>
        </div>
        <div class="stageTwo" :class="(list.IsPayDeposit&&ischeck?'on':'')">
          <div class="">
            <div class="stageRadius"></div>
            <div>Step 2</div>
            <div v-if="!ischeck">Pay balance <span class="price">€ {{priceCount(priceCount(list.Details[0].LowestPrice,list.Details[0].AdvancePrice,'sub'),list.Details[0].Num,'multi').toLocaleString()}}</span></div>
            <div v-if="ischeck">Pay balance <span class="price">€ {{priceCount(list.RealOrderPrice,list.AdvancePrice,'sub').toLocaleString()}}</span></div>
          </div>
          <span class="span"><i></i></span>
        </div>
      </div>
      <div class="cart_list_title check_list cart_list">
        <div class="cart_list_products">Item</div>
        <div class="cart_list_detail"></div>
        <div class="cart_list_price">Price</div>
        <div class="cart_list_number">Quantity</div>
        <div class="cart_list_total">Total</div>
      </div>
      <div class="check_list cart_list" v-for="(item,index) in list.Details" :key="index" v-if="list!=null">
        <div class="cart_list_products">
          <router-link class="cart_img" :to="{path:'/market/item/'+item._id+'?type=1'}">
            <img :src="item.TitImg+'?imageView2/2/w/160'">
            <span class="icon_presale" v-if="item.Presale==1||(list.OrderPresale==1)">Pre-sale</span>
          </router-link>
        </div>
        <div class="cart_list_detail space_between">
          <router-link :to="{path:'/market/item/'+item._id+'?type=1'}">
            <p>{{item.Title}}</p>
          </router-link>
        </div>
        <!-- 非积分 -->
        <div class="cart_list_price" v-if="!item.IsPoints||item.IsPoints<1">
          <del v-if="item.Price!=item.LowestPrice">€ {{item.Price.toLocaleString()}}</del>
          <span v-if="item.Price==item.LowestPrice">€ {{item.Price.toLocaleString()}}</span>
          <span v-if="item.Price!=item.LowestPrice" class="price_red">€ {{item.LowestPrice.toLocaleString()}}</span>
        </div>
        <!-- 积分 -->
        <div class="cart_list_price" v-if="item.IsPoints==1">
          <div class="cart_point_price" v-if="!ischeck">
            <span>{{item.PointsScore}} Points</span>
            <span v-if="item.Price>0">+€ {{item.Price.toLocaleString()}}</span>
          </div>
          <div class="cart_point_price" v-if="ischeck">
            <span>{{item.PointsScore}} Points</span>
            <span v-if="item.Price>0">+€ {{item.Price.toLocaleString()}}</span>
          </div>
        </div>
        <div class="cart_list_number">
          <span>{{item.Num}}</span>
        </div>

        <!-- 非积分 -->
        <div class="cart_list_total" v-if="(!item.IsPoints||(item.IsPoints<1&&!ischeck))||(list.OrderPresale!=2&&ischeck)">
          <span v-if="((list.Details[0].Presale==0||list.Details[0].Presale==null)&&!ischeck)||(list.OrderPresale!=1&&ischeck)">€ {{priceCount(item.LowestPrice,item.Num,'multi').toLocaleString()}}</span>
          <div v-if="(item.Presale==1&&!ischeck)||(ischeck&&!list.IsPayDeposit&&list.OrderPresale==1)" class="itemPresale" >
            <span class="">€ {{ischeck?list.AdvancePrice.toLocaleString():priceCount(list.Details[0].AdvancePrice,list.Details[0].Num,'multi').toLocaleString()}}</span>
            <span class="" v-if="!ischeck">( Balance € {{priceCount(priceCount(list.Details[0].LowestPrice,list.Details[0].AdvancePrice,'sub'),list.Details[0].Num,'multi').toLocaleString()}} )</span>
            <span v-if="ischeck">( Balance € {{priceCount(list.RealOrderPrice,list.AdvancePrice,'sub').toLocaleString()}} )</span>
          </div>
          <div v-if="list.IsPayDeposit&&ischeck" class="itemPresale PayDeposit" >
            <span class="">€ {{list.RealOrderPrice.toLocaleString()}}</span>
            <span class="">( Deposit € {{list.AdvancePrice.toLocaleString()}} )</span>
          </div>
        </div>
        <!-- 积分 -->
        <div class="cart_list_total" v-if="(item.IsPoints==1&&!ischeck)||(list.OrderPresale==2&&ischeck)">
          <div class="cart_point_price" v-if="!ischeck">
            <div>{{priceCount(item.PointsScore,list.Details[0].Num,'multi')}} Points</div>
            <div v-if="item.Price>0">+€ {{priceCount(item.Price,list.Details[0].Num,'multi').toLocaleString()}}</div>
          </div>
          <div class="cart_point_price" v-if="ischeck">
            <div>{{item.TotalPoints}} Points</div>
            <div v-if="item.TotalPrice>0">+€ {{item.TotalPrice.toLocaleString()}}</div>
          </div>
        </div>
      </div>
      <div class="subTotalBox" v-if="list!=null">
        <div class="subTotal" v-if="((list.Details[0].Presale==0||list.Details[0].Presale==null)&&list.Details[0].IsPoints!=1&&!ischeck)||(list.OrderPresale!=1&&ischeck&&list.OrderPresale!=2)">
          <div class="space_between">
            <span>Total</span>
            <span class="price">{{countOrder(list.Details,0)}}</span>
          </div>
          <div class="space_between">
            <span>Quantity</span>
            <span class="">{{countOrder(list.Details,3)}}</span>
          </div>
          <div class="space_between" v-if="countOrder(list.Details,2)>0">
            <span>Discount</span>
            <span class='price price_red'>- {{countOrder(list.Details,2)}}</span>
            <!-- <span class='price price_red' v-if="ischeck">{{priceCount(countOrder(list.Details,2),(list.DiscountPrice!=null?list.DiscountPrice:0),'add')}}</span> -->
          </div>
          <div class="space_between" v-if="ischeck&&list.DiscountPrice>0">
            <span>Staff discount</span>
            <span class='price price_red'>- {{list.DiscountPrice.toLocaleString()}}</span>
          </div>
          <div class="space_between total">
            <span>Total due</span>
            <span class='price'>{{ischeck?list.OrderPrice.toLocaleString():countOrder(list.Details,1)}}</span>
          </div>
          <el-button class='subtn' :disabled="addressList!=null?disabled:true" type="primary" @click="createOrder">{{!ischeck?'Submit order':'Pay now'}}</el-button>
        </div>
        <div class="subTotal" v-if="(list.Details[0].Presale==1&&list.Details[0].IsPoints!=1)||(list.OrderPresale==1)">
          <div class="space_between total" v-if='(list.Details[0].Presale==1&&!ischeck)||(ischeck&&!list.IsPayDeposit)'>
            <span>Pay Deposit</span>
            <span class='price' v-if="!ischeck">{{priceCount(list.Details[0].AdvancePrice,list.Details[0].Num,'multi').toLocaleString()}}</span>
            <span class='price' v-if="ischeck">{{list.AdvancePrice.toLocaleString()}}</span>
          </div>
          <div class="space_between" v-if='ischeck&&list.IsPayDeposit'>
            <span>Total</span>
            <span class="price">{{countOrder(list.Details,0)}}</span>
          </div>
          <div class="space_between" v-if='ischeck&&list.IsPayDeposit'>
            <span>Quantity</span>
            <span class="">{{countOrder(list.Details,3)}}</span>
          </div>
          <div class="space_between" v-if="ischeck&&list.IsPayDeposit">
            <span>Discount</span>
            <span class='price price_red'>- {{countOrder(list.Details,2)}}</span>
          </div>
          <div class="space_between" v-if="ischeck&&list.DiscountPrice>0">
            <span>Staff discount</span>
            <span class='price price_red'>- {{list.DiscountPrice.toLocaleString()}}</span>
          </div>
          <div class="space_between" v-if='ischeck&&list.IsPayDeposit'>
            <span>Deposit</span>
            <span class='price price_red'>- {{list.AdvancePrice.toLocaleString()}}</span>
          </div>
          <div class="space_between total" v-if='ischeck&&list.IsPayDeposit'>
            <span>Total due</span>
            <!-- <span class='price'>{{priceCount(list.RealOrderPrice,(priceCount(list.AdvancePrice,list.Details[0].Num,'multi')),'sub').toLocaleString()}}</span> -->
            <span class='price'>{{priceCount(list.RealOrderPrice,list.AdvancePrice,'sub').toLocaleString()}}</span>
          </div>
          <el-button class='subtn' :disabled="disabled" type="primary" @click="createOrder">
            {{((list.Details[0].Presale==1&&!ischeck)||(ischeck&&!list.IsPayDeposit))?'Pay Deposit':'Pay balance'}}
          </el-button>
          <div class="space_between orderPresale">
            <span class="textPresale">Discounts will be applied to the balance payment</span>
          </div>
        </div>
        <!-- 积分 -->
        <!-- 商品详情 -->
        <div class="subTotal" v-if="list.Details[0].IsPoints==1&&!ischeck">
          <div class="space_between">
            <span>Points</span>
            <span class="">{{priceCount(list.Details[0].PointsScore,list.Details[0].Num,'multi')}} Points</span>
          </div>
          <div class="space_between" v-if="(list.Details[0].Price>0&&!ischeck)">
            <span>Price</span>
            <span class="">{{priceCount(list.Details[0].Price,list.Details[0].Num,'multi').toLocaleString()}}</span>
          </div>
          <div class="space_between" >
            <span>Shipping fee</span>
            <span class="">Pay on delivery</span>
          </div>
          <div class="space_between total">
            <span>Total due</span>
            <span class='total_point'>{{priceCount(list.Details[0].PointsScore,list.Details[0].Num,'multi')}} Points <i v-if="(list.Details[0].Price>0&&!ischeck)">+ € {{priceCount(list.Details[0].Price,list.Details[0].Num,'multi').toLocaleString()}}</i></span>
          </div>
          <el-button class='subtn' :disabled="disabled" type="primary" @click="createOrder">{{!ischeck?'Submit order':'Pay now'}}</el-button>
        </div>
        <!-- 订单详情 -->
        <div class="subTotal" v-if="list.OrderPresale==2&&ischeck">
          <div class="space_between">
            <span>Points</span>
            <span class="">{{list.RealPoints}} Points</span>
          </div>
          <div class="space_between" v-if="(list.RealOrderPrice>0)">
            <span>Price</span>
            <span class="">{{list.RealOrderPrice.toLocaleString()}}</span>
          </div>
          <div class="space_between" >
            <span>Shipping fee</span>
            <span class="">Pay on delivery</span>
          </div>
          <div class="space_between total">
            <span>Total due</span>
            <span class='total_point'>{{list.RealPoints}} Points <i v-if="(list.RealOrderPrice>0)">+ € {{list.RealOrderPrice.toLocaleString()}}</i></span>
          </div>
          <el-button class='subtn' :disabled="disabled" type="primary" @click="createOrder">{{!ischeck?'Submit order':'Pay now'}}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getInfo, numAdd, numSub, numMulti } from "@/api/public";
import ToAddress from '@/components/dialog/address'
export default {
  name: 'cart',
  components: { ToAddress },
  data() {
    return {
      userInfo: getInfo(),
      loading: false,
      disabled: false,
      isAddShow: false,
      isaddlist: false,
      title: "",
      isAdd: 0,
      addressItem: null,
      isSet: false,
      dislogType: this.$enumInfo.dislogType,
      pi: this.$enumInfo.addressPage.pageindex,
      ps: this.$enumInfo.addressPage.pagesize,
      addressList: null,
      addressCount: 0,
      list: null,
      ischeck: this.$route.params.id ? true : false
    }
  },
  filters: {
    setProvice(val){
      // var regex = /(<([^>]+)>)/ig;
      if(val!=null){
        // val=val.replace(regex,'');
        val=val.replace(/\-/g,' ');
        //val=val.replace('&nbsp;','');
      }
      return val
    }
  },
  mounted() {},
  created() {
    console.log(this.ischeck)
    if (this.ischeck) {
      this.getOrderDetail(this.$route.params.id)
    }else{
      this.list = window.sessionStorage.getItem('miaocheck');
      this.list = JSON.parse(this.list);
      this.getAddress()
    }
  },
  methods: {
    //计算价格
    priceCount(num1,num2,type){
      let num=0;
      if(type=='add'){
          num = numAdd(num1, num2)
      }
      if(type=='sub'){
          num = numSub(num1, num2)
      }
      if(type=='multi'){
          num = numMulti(num1, num2)
      }
      return num.toLocaleString()
    },
    getOrderDetail(val,type) {
      let that = this;
      that.loading = true;
      let data = { Id: val }
      that.$get(that.$interface.GetOrderById, data).then(res => {
        if (res.Result != 0) {
          var obj=res.Data
          obj.Details=obj.OrderDetails
          obj.OrderPrice=obj.RealOrderPrice
          obj.AddressId=obj.AddressId
          that.list=obj
          that.getAddress()
          // 支付订单判断
          if(type==1){
            console.log(obj)
            // 订单类型 0普通订单 1预售订单 2积分订单
            if(obj.OrderPresale!=1){
              // 非预售订单
              if(obj.Status!=1){
                that.$router.push({ path: '/order/detail/' + that.$route.params.id })
              }else{
                that.$router.push({ path: '/pay/' + that.$route.params.id })
              }
            }else{
              // 预售订单
              if(obj.Status!=1){
                that.$router.push({ path: '/order/detail/' + that.$route.params.id })
              }else{
                if(obj.PayType==2&&(obj.PayCheck==1||obj.PayCheck==3)){
                  that.$router.push({ path: '/order/detail/' + that.$route.params.id })
                }else{
                that.$router.push({ path: '/pay/' + that.$route.params.id })
                }
              }
            }
            that.disabled = false;
            that.loading = false;
            //that.$message.error('该订单状态已改变');
          }
        } else {
          that.$message.error(res.Msg);
        }
        that.loading = false
      })
    },
    createOrder() {
      let that = this;
      that.loading = true;
      that.disabled = true;
      if (!that.ischeck) {
        let addressDetail = that.addressList[that.isAdd];
        let commoditys = [];
        that.list.Details.map(item => {
          commoditys.push({ commodityId: item.CommodityId, num: item.Num })
        })
        let isCrat = that.list.isCrat || 0
        let data = {
          memberId: that.userInfo._id,
          nickName: that.userInfo.NickName,
          addressId: addressDetail._id,
          userName: addressDetail.UserName,
          mobile: addressDetail.Mobile,
          provice: addressDetail.Provice,
          city: addressDetail.City,
          addressDetail: addressDetail.AddressDetail,
          country: addressDetail.Country,
          CompanyName: addressDetail.CompanyName,
          Email:addressDetail.Email,
          TaxCode:addressDetail.TaxCode,
          ZipCode:addressDetail.ZipCode,
          'isCart': isCrat,
          commoditys: commoditys
        }
        //console.log(data,'data',addressDetail)
        that.$post(that.$interface.CreateOrder, data).then(res => {

          if (res.Result != 0) {
            if(res.Data.Status==2){
              that.$router.push({ path: '/user/order?type=2'})
            }else{
              that.$router.push({ path: '/pay/' + res.Data.OrderId })
            }
            //
          } else {
            that.$message.error(res.Msg);
          }
          that.loading = false;
          that.disabled = false;
        })
      } else {
          that.disabled = true;
        that.getOrderDetail(this.$route.params.id,1)
        //this.$route.params.id
      }
    },
    getAddress() {
      let that = this;
      that.loading = true;
      let data = { MemberId: that.userInfo._id, PageIndex: that.pi, PageSize: that.ps }
      that.$get(that.$interface.SearchShippingAddresses, data).then(res => {
        if (res.Result != 0) {
          that.addressList = res.Data;
          that.addressCount = res.Count;
          if(res.Count<0){
            that.disabled = true;
          }
          if (that.ischeck) {
            res.Data.map((it, i) => {
              if (it._id == that.list.AddressId) {
                that.isAdd = i
              }
            })
          }
        }
        that.loading = false;
      })
    },
    IsShow() {
      this.isAddShow = !this.isAddShow
    },
    setAddress(val, type, obj) {
      if (type == 1) {
        this.title = 'Edit shipping address'
        this.addressItem = JSON.parse(JSON.stringify(obj))
      } else {
        this.title = 'Add shipping address'
      }
      this.isSet = type > 0 ? false : true;
      this.dislogType[val] = true;
    },
    closeDialog(val, bol) {
      this.dislogType[val] = bol
      this.getAddress()
    },
    setOnlyAddress(val) {
      this.isAdd = val;
      if (this.ischeck) {
        this.upDataOrder()
      }
    },
    upDataOrder() {
      let that = this;
      that.loading = true;
      that.disabled = true;
      let newaddInfo = that.addressList[this.isAdd]
      let data = {
        id: this.$route.params.id,
        addressId: newaddInfo._id,
        userName: newaddInfo.UserName,
        mobile: newaddInfo.Mobile,
        provice: newaddInfo.Provice,
        city: newaddInfo.City,
        addressDetail: newaddInfo.AddressDetail,
        country: newaddInfo.Country,
        CompanyName: newaddInfo.CompanyName,
        TaxCode: newaddInfo.TaxCode,
        Email: newaddInfo.Email,
        ZipCode: newaddInfo.ZipCode,
      }
      that.$post(that.$interface.ModifyOrderAdress, data).then(res => {
        if (res.Result != 0) {

          that.getOrderDetail(that.$route.params.id)
          //that.$emit('closeDialog', 'setOrderAddress', false, 1)
        } else {
          that.$message.error(res.Msg);
        }
        that.disabled = false;
        that.loading = false;
      })
    },
    // 计算购物车价格  type 0:总价，1:共计，2:优惠
    countOrder(obj, type) {
      let inall = 0
      let reduction = 0
      let total = 0
      let num = 0
      if (obj.length > 0) {
        //this.disabled = false;
        obj.map(res => {
          inall += numMulti(res.Price, res.Num)
          total += numMulti(res.LowestPrice, res.Num)
          num = numAdd(num, res.Num)
        })
        if (type == 0) {
          return inall.toLocaleString()
        }
        if (type == 1) {
          return total.toLocaleString()
        }
        if (type == 2) {
          return numSub(inall, total).toLocaleString()
        }
        if (type == 3) {
          return num
        } else {
          return 0
        }
      } else {
       // this.disabled = true;
        return 0
      }
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/pay.css";

</style>



// WEBPACK FOOTER //
// src/pages/pay/checkout.vue